import { render, staticRenderFns } from "./LoginForgotUsername.vue?vue&type=template&id=722d3531&scoped=true"
import script from "./LoginForgotUsername.vue?vue&type=script&lang=ts"
export * from "./LoginForgotUsername.vue?vue&type=script&lang=ts"
import style0 from "./LoginForgotUsername.vue?vue&type=style&index=0&id=722d3531&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722d3531",
  null
  
)

export default component.exports